import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BookShipmentReview from '../PickupShipment/PickupShipmentLTL';

function RatesDrawer({
  open,
  onClose,
  bookingData
}) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        height: '100vh',
        width: { xs: '100%', sm: '70%', md: '65%' },
        zIndex: 1300,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#fff',
        boxShadow: '-4px 0 24px rgba(0,0,0,0.12)',
        borderLeft: '1px solid',
        borderColor: 'divider'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
          flexShrink: 0,
          bgcolor: '#fff',
          zIndex: 1
        }}
      >
        <IconButton onClick={onClose} size='small' sx={{ mr: 1 }}>
          <ArrowBackIcon fontSize='small' />
        </IconButton>
        <Typography variant='subtitle1' fontWeight={700} fontSize={14}>
          Book Shipment
        </Typography>
      </Box>

      {/* BookShipmentReview fills the rest, scrolls internally */}
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        <BookShipmentReview
          hideServices={true}
          location={{ state: bookingData }}
        />
      </Box>
    </Box>
  );
}

export default RatesDrawer;
